import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {Observable} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';


import {ErrorService, EventService} from '..';
import {WebhookMacro, WebhookTestResponse} from '../../core/models/';
import {ConfigService} from './config.service';
import {CreateUpdateWebhookRequest, Webhook, WebhookResponse} from '../models/webhook';

@Injectable({ providedIn: 'root' })
export class WebhookService {
    private baseUrl = ConfigService.getApiEndpoint() + 'v1/webhook';

    constructor(
        private http: HttpClient,
        private eventService: EventService,
        private error: ErrorService
    ) { }

    getAllMacros(): Observable<WebhookMacro[]> {
        return this.http.get<WebhookMacro[]>(ConfigService.getApiEndpoint() + 'v1/webhookmacros').pipe(
            catchError(this.error.handleError('Could not fetch macros', null))
        );
    }

    find(projectId: string, request: any): Observable<WebhookResponse> {
        return this.http.get<WebhookResponse>(ConfigService.getApiEndpoint() + 'v1/webhook', { params: request }).pipe(
            catchError(this.error.handleError('Could not fetch webhooks', null))
        );
    }

    getOne(projectId: string, id: string): Observable<Webhook> {
        return this.http.get<Webhook>(this.baseUrl + '/' + id, {params: {projectId: projectId}}).pipe(
            catchError(this.error.handleError('get webhook', null))
        );
    }

    create(projectId: string, request: CreateUpdateWebhookRequest): Observable<Webhook> {
        return this.http.post<Webhook>(this.baseUrl, request, {params: {projectId: projectId}}).pipe(
            tap(_ => this.eventService.addAlert(`created webhook`)),
            catchError(this.error.handleError('create webhook', null))
        );
    }

    update(projectId: string, id: string, webhook: CreateUpdateWebhookRequest): Observable<Webhook> {
        return this.http.put<Webhook>(this.baseUrl + '/' + id, webhook, {params: {projectId: projectId}}).pipe(
            tap(_ => this.eventService.addAlert(`updated webhook: ${id}`)),
            catchError(this.error.handleError('update webhook', null))
        );
    }

    delete(projectId: string, id: string) {
        return this.http.delete(this.baseUrl + '/' + id, {params: {projectId: projectId}}).pipe(
            tap(_ => this.eventService.addAlert(`deleted webhook`)),
            catchError(this.error.handleError('update webhook', null))
        );
    }

    test(projectId: string, webhook: CreateUpdateWebhookRequest): Observable<WebhookTestResponse> {
        return this.http.post<CreateUpdateWebhookRequest>(ConfigService.getApiEndpoint() + 'v1/webhooktest', webhook, {params: {projectId: projectId}}).pipe(
            tap(_ => this.eventService.addAlert(`test webhook`)),
            catchError(this.error.handleError('testWebhook', null))
        );
    }

}
